import { getFirestore, doc, getDoc } from 'firebase/firestore';

/**
 * Poll a payments/{paymentIntentId} doc until it’s either
 *   { status: "completed", orderId }  OR  { status: "refunded" }
 *
 * @param {string} pid   Stripe PaymentIntent ID
 * @param {number} [timeoutMs=20000]
 * @returns {Promise<{ ok:boolean, orderId?:string }>} ok==false → refunded
 */
export async function waitForPayment(pid, timeoutMs = 20_000) {
    const db = getFirestore();
    const ref = doc(db, 'payments', pid);

    const started = Date.now();
    while (Date.now() - started < timeoutMs) {
        const snap = await getDoc(ref);
        if (snap.exists()) {
            const data = snap.data();
            if (data.status === 'completed' && data.orderId)
                return { ok: true, orderId: data.orderId };

            if (data.status === 'refunded')
                return { ok: false };
        }
        await new Promise(r => setTimeout(r, 1000));
    }
    return { ok: false };       // timed-out → treat as failure
}
